import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form-text"
export default class extends Controller {
  connect() {
    if (this.element.dataset.focus) {
      this.element.focus()
    }
  }
}
